const th = {
  ng: {
    ranking: {
      menu: "Ranking / ระดับสมาชิก",
      title: "ระดับสมาชิก",
      subtitle: "สะสม EXP เพื่อปลดล็อกสิทธิประโยชน์",
      current: "ระดับปัจจุบัน",
      next: "ระดับถัดไป",
      noCurrent: "ยังไม่มีระดับสมาชิก",
      highest: "คุณอยู่ในระดับสูงสุดแล้ว",
      progress: "ความคืบหน้าสู่ {{name}}",
      exp: "EXP",
      catalog: "ระดับและสิทธิประโยชน์",
      reward: "รางวัล",
      noReward: "ระดับนี้ไม่มีรางวัลให้รับ",
      requiredExp: "EXP ที่ต้องใช้",
      turnover: "ยอดเทิร์นที่ต้องทำ",
      withdrawMax: "ถอนสูงสุด",
      unit: "บาท",
      unavailable: "ไม่ระบุ",
      noRanks: "ยังไม่มีข้อมูลระดับสมาชิก",
      loading: "กำลังโหลดระดับสมาชิก",
      loadError: "โหลดข้อมูล Ranking ไม่สำเร็จ กรุณาลองใหม่หรือติดต่อพนักงาน",
      retry: "ลองใหม่",
      refresh: "อัปเดตข้อมูล",
      contact: "ติดต่อพนักงาน",
      close: "ปิด",
      details: "รายละเอียด {{name}}",
      currentBadge: "ระดับของคุณ",
      nextBadge: "ระดับถัดไป",
      available: "รับรางวัลได้",
      locked: "ยังไม่ถึงระดับนี้",
      claimed: "มีรายการรับรางวัลเดือนนี้",
      claim: "รับรางวัล",
      claiming: "กำลังส่งคำขอ",
      confirm: "ยืนยันรับรางวัล {{name}}",
      confirmNote: "รางวัล {{reward}} บาท · ยอดเทิร์น {{turnover}} บาท · ถอนสูงสุด {{withdrawMax}} บาท",
      cancel: "ยกเลิก",
      claimRules: "รับรางวัลแต่ละระดับได้ตามสิทธิ์ของเดือนปัจจุบัน เครดิตต้องไม่เกิน 5 บาทและไม่มีเทิร์นค้าง ระบบจะตรวจสิทธิ์อีกครั้งเมื่อรับรางวัล",
      accepted: "ส่งคำขอรับรางวัลแล้ว กดอัปเดตข้อมูลเพื่อตรวจสอบรายการและเครดิต",
      unknown: "ยังยืนยันผลรับรางวัลไม่ได้ กรุณาตรวจผลคำขอเดิมก่อนรับใหม่ หรือติดต่อพนักงาน",
      check: "ตรวจผลคำขอเดิม",
      recorded: "พบรายการรับรางวัลแล้ว กรุณาตรวจสอบเครดิต หากยังไม่ได้รับให้ติดต่อพนักงาน",
      notRecorded: "ตรวจแล้วไม่พบรายการรับรางวัล และระบบยังให้สิทธิ์รับได้ คุณสามารถลองรับอีกครั้งหรือติดต่อพนักงาน",
      rejected: "รับรางวัลไม่สำเร็จ ตรวจสอบเงื่อนไขแล้วอัปเดตข้อมูลเพื่อลองใหม่ หรือติดต่อพนักงาน",
      loginRequired: "กรุณาเข้าสู่ระบบเพื่อดูระดับสมาชิก",
      storageError: "บันทึกคำขอไม่สำเร็จ กรุณาลองใหม่หรือติดต่อพนักงาน",
      claimPending: "คำขอนี้อยู่ระหว่างตรวจสอบ",
      creditRefreshError: "อัปเดตเครดิตไม่สำเร็จ ลองอัปเดตข้อมูลอีกครั้ง",
      percent: "{{value}}%",
    },
  },
};

const en = {
  ng: {
    ranking: {
      menu: "Ranking / Member level",
      title: "Member level",
      subtitle: "Earn EXP to unlock benefits",
      current: "Current level",
      next: "Next level",
      noCurrent: "No member level yet",
      highest: "You have reached the highest level",
      progress: "Progress to {{name}}",
      exp: "EXP",
      catalog: "Levels and benefits",
      reward: "Reward",
      noReward: "This level has no reward to claim",
      requiredExp: "Required EXP",
      turnover: "Required turnover",
      withdrawMax: "Maximum withdrawal",
      unit: "THB",
      unavailable: "Not specified",
      noRanks: "No member levels available yet",
      loading: "Loading member levels",
      loadError: "Unable to load Ranking. Try again or contact support.",
      retry: "Try again",
      refresh: "Refresh",
      contact: "Contact support",
      close: "Close",
      details: "{{name}} details",
      currentBadge: "Your level",
      nextBadge: "Next level",
      available: "Reward available",
      locked: "Level not reached yet",
      claimed: "A reward claim exists this month",
      claim: "Claim reward",
      claiming: "Sending request",
      confirm: "Confirm {{name}} reward claim",
      confirmNote: "Reward: {{reward}} THB · Turnover: {{turnover}} THB · Maximum withdrawal: {{withdrawMax}} THB",
      cancel: "Cancel",
      claimRules: "Rewards for each level depend on your eligibility for the current month. Your credit must be no more than 5 THB with no outstanding turnover. Eligibility is checked again when you claim.",
      accepted: "Reward request submitted. Refresh to check the claim and your credit.",
      unknown: "The reward result is not confirmed. Check the previous request before claiming again, or contact support.",
      check: "Check previous request",
      recorded: "A reward claim was found. Check your credit and contact support if it has not arrived.",
      notRecorded: "No reward claim was found, and you are still eligible. You can try claiming again or contact support.",
      rejected: "Reward claim failed. Check the conditions and refresh to try again, or contact support.",
      loginRequired: "Sign in to view your member level",
      storageError: "Unable to save the request. Try again or contact support.",
      claimPending: "This request is being checked",
      creditRefreshError: "Unable to refresh your credit. Try refreshing again.",
      percent: "{{value}}%",
    },
  },
};

const cn = {
  ng: {
    ranking: {
      menu: "Ranking / 会员等级",
      title: "会员等级",
      subtitle: "累积 EXP，解锁更多权益",
      current: "当前等级",
      next: "下一等级",
      noCurrent: "暂无会员等级",
      highest: "您已达到最高等级",
      progress: "升至 {{name}} 的进度",
      exp: "EXP",
      catalog: "等级与权益",
      reward: "奖励",
      noReward: "此等级没有可领取的奖励",
      requiredExp: "所需 EXP",
      turnover: "所需流水",
      withdrawMax: "最高提款额",
      unit: "泰铢",
      unavailable: "未指定",
      noRanks: "暂无会员等级信息",
      loading: "正在加载会员等级",
      loadError: "无法加载 Ranking，请重试或联系客服。",
      retry: "重试",
      refresh: "刷新",
      contact: "联系客服",
      close: "关闭",
      details: "{{name}} 详情",
      currentBadge: "您的等级",
      nextBadge: "下一等级",
      available: "可领取奖励",
      locked: "尚未达到此等级",
      claimed: "本月已有奖励领取记录",
      claim: "领取奖励",
      claiming: "正在提交请求",
      confirm: "确认领取 {{name}} 奖励",
      confirmNote: "奖励 {{reward}} 泰铢 · 流水 {{turnover}} 泰铢 · 最高提款额 {{withdrawMax}} 泰铢",
      cancel: "取消",
      claimRules: "各等级奖励按本月领取资格发放。余额不得超过 5 泰铢，且不能有未完成的流水。领取时系统将再次检查资格。",
      accepted: "奖励请求已提交。请刷新以检查领取记录和余额。",
      unknown: "奖励结果尚未确认。再次领取前，请查询原请求或联系客服。",
      check: "查询原请求",
      recorded: "已找到奖励领取记录。请检查余额，若尚未到账请联系客服。",
      notRecorded: "查询后未找到奖励领取记录，且您仍有领取资格。您可以再次尝试领取或联系客服。",
      rejected: "奖励领取失败。请检查条件并刷新后重试，或联系客服。",
      loginRequired: "请登录以查看会员等级",
      storageError: "无法保存请求，请重试或联系客服。",
      claimPending: "此请求正在核查中",
      creditRefreshError: "无法更新余额，请再次刷新。",
      percent: "{{value}}%",
    },
  },
};

const mm = {
  ng: {
    ranking: {
      menu: "Ranking / အသင်းဝင်အဆင့်",
      title: "အသင်းဝင်အဆင့်",
      subtitle: "အကျိုးခံစားခွင့်များ ရရှိရန် EXP စုဆောင်းပါ",
      current: "လက်ရှိအဆင့်",
      next: "နောက်အဆင့်",
      noCurrent: "အသင်းဝင်အဆင့် မရှိသေးပါ",
      highest: "အမြင့်ဆုံးအဆင့်သို့ ရောက်ရှိပြီးပါပြီ",
      progress: "{{name}} သို့ တိုးတက်မှု",
      exp: "EXP",
      catalog: "အဆင့်များနှင့် အကျိုးခံစားခွင့်များ",
      reward: "ဆုကြေး",
      noReward: "ဤအဆင့်တွင် ရယူရန် ဆုကြေးမရှိပါ",
      requiredExp: "လိုအပ်သော EXP",
      turnover: "လိုအပ်သော လောင်းကစားပမာဏ",
      withdrawMax: "အများဆုံး ငွေထုတ်ပမာဏ",
      unit: "ဘတ်",
      unavailable: "မသတ်မှတ်ထားပါ",
      noRanks: "အသင်းဝင်အဆင့် အချက်အလက် မရှိသေးပါ",
      loading: "အသင်းဝင်အဆင့်များ ရယူနေသည်",
      loadError: "Ranking အချက်အလက် ရယူ၍မရပါ။ ထပ်ကြိုးစားပါ သို့မဟုတ် ဝန်ထမ်းကို ဆက်သွယ်ပါ။",
      retry: "ထပ်ကြိုးစားရန်",
      refresh: "အချက်အလက် ပြန်တင်ရန်",
      contact: "ဝန်ထမ်းကို ဆက်သွယ်ရန်",
      close: "ပိတ်ရန်",
      details: "{{name}} အသေးစိတ်",
      currentBadge: "သင့်အဆင့်",
      nextBadge: "နောက်အဆင့်",
      available: "ဆုကြေး ရယူနိုင်သည်",
      locked: "ဤအဆင့်သို့ မရောက်သေးပါ",
      claimed: "ယခုလတွင် ဆုကြေးရယူမှု မှတ်တမ်းရှိသည်",
      claim: "ဆုကြေး ရယူရန်",
      claiming: "တောင်းဆိုချက် ပို့နေသည်",
      confirm: "{{name}} ဆုကြေးရယူမှု အတည်ပြုရန်",
      confirmNote: "ဆုကြေး {{reward}} ဘတ် · လောင်းကစားပမာဏ {{turnover}} ဘတ် · အများဆုံး ငွေထုတ်ပမာဏ {{withdrawMax}} ဘတ်",
      cancel: "ပယ်ဖျက်ရန်",
      claimRules: "အဆင့်တစ်ခုစီ၏ ဆုကြေးကို ယခုလအတွက် ရပိုင်ခွင့်အတိုင်း ရယူနိုင်သည်။ လက်ကျန်ငွေသည် 5 ဘတ်ထက် မပိုရဘဲ လုပ်ဆောင်ရန် လောင်းကစားပမာဏ မကျန်ရပါ။ ရယူချိန်တွင် စနစ်က ရပိုင်ခွင့်ကို ထပ်စစ်မည်။",
      accepted: "ဆုကြေးတောင်းဆိုချက် ပို့ပြီးပါပြီ။ မှတ်တမ်းနှင့် လက်ကျန်ငွေ စစ်ရန် အချက်အလက် ပြန်တင်ပါ။",
      unknown: "ဆုကြေးရလဒ်ကို အတည်မပြုနိုင်သေးပါ။ ထပ်မရယူမီ ယခင်တောင်းဆိုချက်ကို စစ်ပါ သို့မဟုတ် ဝန်ထမ်းကို ဆက်သွယ်ပါ။",
      check: "ယခင်တောင်းဆိုချက် စစ်ရန်",
      recorded: "ဆုကြေးရယူမှု မှတ်တမ်းတွေ့သည်။ လက်ကျန်ငွေ စစ်ပါ။ မရရှိသေးပါက ဝန်ထမ်းကို ဆက်သွယ်ပါ။",
      notRecorded: "စစ်ဆေးပြီး ဆုကြေးရယူမှု မှတ်တမ်းမတွေ့ပါ။ ရယူခွင့်လည်း ရှိနေသေးသည်။ ထပ်ရယူကြည့်နိုင်သည် သို့မဟုတ် ဝန်ထမ်းကို ဆက်သွယ်ပါ။",
      rejected: "ဆုကြေးရယူမှု မအောင်မြင်ပါ။ စည်းကမ်းများ စစ်ပြီး အချက်အလက် ပြန်တင်ကာ ထပ်ကြိုးစားပါ သို့မဟုတ် ဝန်ထမ်းကို ဆက်သွယ်ပါ။",
      loginRequired: "အသင်းဝင်အဆင့် ကြည့်ရန် အကောင့်ဝင်ပါ",
      storageError: "တောင်းဆိုချက် သိမ်း၍မရပါ။ ထပ်ကြိုးစားပါ သို့မဟုတ် ဝန်ထမ်းကို ဆက်သွယ်ပါ။",
      claimPending: "ဤတောင်းဆိုချက်ကို စစ်ဆေးနေသည်",
      creditRefreshError: "လက်ကျန်ငွေ ပြန်တင်၍မရပါ။ အချက်အလက် ထပ်ပြန်တင်ပါ။",
      percent: "{{value}}%",
    },
  },
};

const newgameRanking = { th, en, cn, mm };

export default newgameRanking;
